import React from 'react';
import styles from '../DonationForm.module.css';

// The monthly donation amount input + shortcuts, plus the number-of-
// payments input + 6/12/24-month/Unlimited duration shortcuts.
// Extracted VERBATIM from DonationAmountSection's render.
export default function MonthlyAmountFields({
  clientSecret, isForever, monthlyAmount, numberOfPayments, onClientSecretChange,
  paymentIntentCreatedRef, preservedIsForever, preservedMonthlyAmount, preservedNumberOfPayments,
  setClientSecret, setIsForever, setMonthlyAmount, setNumberOfPayments, setPaymentIntentId,
  setPreservedMonthlyAmount, setShowPaymentElement, setShowPaymentForm, showPaymentForm,
}) {
  return (
    <>
      <div>
        <input
          className={styles.input}
          type="text"
          inputMode="decimal"
          id="monthlyAmount"
          placeholder="$0.00"
          value={
            monthlyAmount
              ? `$${monthlyAmount}`
              : (preservedMonthlyAmount ? `$${parseFloat(preservedMonthlyAmount).toFixed(2)}` : '')
          }
          onChange={(e) => {
            if (!(showPaymentForm && !!clientSecret)) {
              let val = e.target.value.replace(/[^0-9.]/g, '');
              const parts = val.split('.');
              if (parts.length > 2) val = parts[0] + '.' + parts.slice(1).join('');
              if (parts[1] && parts[1].length > 2) val = parts[0] + '.' + parts[1].substring(0, 2);
              setMonthlyAmount(val);
              if (clientSecret) {
                setClientSecret(null);
                setShowPaymentElement(false);
                setShowPaymentForm(false);
                setPaymentIntentId(null);
                paymentIntentCreatedRef.current = false;
                if (onClientSecretChange) {
                  onClientSecretChange(null);
                }
              }
            }
          }}
          onBlur={(e) => {
            if (!(showPaymentForm && !!clientSecret)) {
              const raw = e.target.value.replace(/[^0-9.]/g, '');
              const val = parseFloat(raw);
              if (!isNaN(val) && val > 0) {
                const formatted = val.toFixed(2);
                setMonthlyAmount(formatted);
                if (preservedMonthlyAmount) {
                  setPreservedMonthlyAmount(val);
                }
              }
            }
          }}
          readOnly={showPaymentForm && !!clientSecret}
          required
        />
        <div className={styles.quickShortcuts}>
          <button
    className={styles.shortcutButton}
            type="button"
            onClick={() => {
              if (!(showPaymentForm && !!clientSecret)) {
                setMonthlyAmount('25.00');
                // Clear payment intent when amount changes
                if (clientSecret) {
                  setClientSecret(null);
                  setShowPaymentElement(false);
                  setShowPaymentForm(false);
                  setPaymentIntentId(null);
                  paymentIntentCreatedRef.current = false;
                  if (onClientSecretChange) {
                    onClientSecretChange(null);
                  }
                }
              }
            }}
            disabled={showPaymentForm && !!clientSecret}
          >
            $25
          </button>
          <button
    className={styles.shortcutButton}
            type="button"
            onClick={() => {
              if (!(showPaymentForm && !!clientSecret)) {
                setMonthlyAmount('50.00');
                // Clear payment intent when amount changes
                if (clientSecret) {
                  setClientSecret(null);
                  setShowPaymentElement(false);
                  setShowPaymentForm(false);
                  setPaymentIntentId(null);
                  paymentIntentCreatedRef.current = false;
                  if (onClientSecretChange) {
                    onClientSecretChange(null);
                  }
                }
              }
            }}
            disabled={showPaymentForm && !!clientSecret}
          >
            $50
          </button>
          <button
    className={styles.shortcutButton}
            type="button"
            onClick={() => {
              if (!(showPaymentForm && !!clientSecret)) {
                setMonthlyAmount('100.00');
                // Clear payment intent when amount changes
                if (clientSecret) {
                  setClientSecret(null);
                  setShowPaymentElement(false);
                  setShowPaymentForm(false);
                  setPaymentIntentId(null);
                  paymentIntentCreatedRef.current = false;
                  if (onClientSecretChange) {
                    onClientSecretChange(null);
                  }
                }
              }
            }}
            disabled={showPaymentForm && !!clientSecret}
          >
            $100
          </button>
          <button
    className={styles.shortcutButton}
            type="button"
            onClick={() => {
              if (!(showPaymentForm && !!clientSecret)) {
                setMonthlyAmount('200.00');
                // Clear payment intent when amount changes
                if (clientSecret) {
                  setClientSecret(null);
                  setShowPaymentElement(false);
                  setShowPaymentForm(false);
                  setPaymentIntentId(null);
                  paymentIntentCreatedRef.current = false;
                  if (onClientSecretChange) {
                    onClientSecretChange(null);
                  }
                }
              }
            }}
            disabled={showPaymentForm && !!clientSecret}
          >
            $200
          </button>
          <button
    className={styles.shortcutButton}
            type="button"
            onClick={() => {
              if (!(showPaymentForm && !!clientSecret)) {
                setMonthlyAmount('500.00');
                // Clear payment intent when amount changes
                if (clientSecret) {
                  setClientSecret(null);
                  setShowPaymentElement(false);
                  setShowPaymentForm(false);
                  setPaymentIntentId(null);
                  paymentIntentCreatedRef.current = false;
                  if (onClientSecretChange) {
                    onClientSecretChange(null);
                  }
                }
              }
            }}
            disabled={showPaymentForm && !!clientSecret}
          >
            $500
          </button>
          <button
    className={styles.shortcutButton}
            type="button"
            onClick={() => {
              if (!(showPaymentForm && !!clientSecret)) {
                setMonthlyAmount('1000.00');
                // Clear payment intent when amount changes
                if (clientSecret) {
                  setClientSecret(null);
                  setShowPaymentElement(false);
                  setShowPaymentForm(false);
                  setPaymentIntentId(null);
                  paymentIntentCreatedRef.current = false;
                  if (onClientSecretChange) {
                    onClientSecretChange(null);
                  }
                }
              }
            }}
            disabled={showPaymentForm && !!clientSecret}
          >
            $1000
          </button>
        </div>
      </div>
      <div>
        <input
    className={styles.input}
          type="number"
          id="numberOfPayments"
          min="1"
          max="120"
          placeholder={(preservedIsForever || isForever) ? "Unlimited" : "Enter number of payments"}
          value={
            (preservedIsForever || isForever)
              ? ''
              : (preservedNumberOfPayments
                  ? (typeof preservedNumberOfPayments === 'number'
                      ? preservedNumberOfPayments.toString()
                      : preservedNumberOfPayments === 'forever'
                        ? ''
                        : preservedNumberOfPayments.toString())
                  : numberOfPayments)
          }
          onChange={(e) => {
            if (!(showPaymentForm && !!clientSecret)) {
              setNumberOfPayments(e.target.value);
              setIsForever(false);
              // Clear payment intent when number of payments changes
              if (clientSecret) {
                setClientSecret(null);
                setShowPaymentElement(false);
                setShowPaymentForm(false);
                setPaymentIntentId(null);
                paymentIntentCreatedRef.current = false;
                if (onClientSecretChange) {
                  onClientSecretChange(null);
                }
              }
            }
          }}
          readOnly={(preservedIsForever || isForever) || (showPaymentForm && !!clientSecret)}
          required={!(preservedIsForever || isForever)}
        />
    <div className={`${styles.quickShortcuts} ${styles.durationShortcuts}`}>
      <button
        className={`${styles.shortcutButton} ${(preservedNumberOfPayments === 6 || numberOfPayments === '6') && !(preservedIsForever || isForever) ? styles.selected : ''}`}
        type="button"
        onClick={() => {
          if (!(showPaymentForm && !!clientSecret)) {
            setNumberOfPayments('6');
            setIsForever(false);
            // Clear payment intent when number of payments changes
            if (clientSecret) {
              setClientSecret(null);
              setShowPaymentElement(false);
              setShowPaymentForm(false);
              setPaymentIntentId(null);
              paymentIntentCreatedRef.current = false;
              if (onClientSecretChange) {
                onClientSecretChange(null);
              }
            }
          }
        }}
        disabled={(preservedIsForever || isForever) || (showPaymentForm && !!clientSecret)}
      >
        6 mo
      </button>
      <button
        className={`${styles.shortcutButton} ${(preservedNumberOfPayments === 12 || numberOfPayments === '12') && !(preservedIsForever || isForever) ? styles.selected : ''}`}
        type="button"
        onClick={() => {
          if (!(showPaymentForm && !!clientSecret)) {
            setNumberOfPayments('12');
            setIsForever(false);
            // Clear payment intent when number of payments changes
            if (clientSecret) {
              setClientSecret(null);
              setShowPaymentElement(false);
              setShowPaymentForm(false);
              setPaymentIntentId(null);
              paymentIntentCreatedRef.current = false;
              if (onClientSecretChange) {
                onClientSecretChange(null);
              }
            }
          }
        }}
        disabled={(preservedIsForever || isForever) || (showPaymentForm && !!clientSecret)}
      >
        12 mo
      </button>
      <button
        className={`${styles.shortcutButton} ${(preservedNumberOfPayments === 24 || numberOfPayments === '24') && !(preservedIsForever || isForever) ? styles.selected : ''}`}
        type="button"
        onClick={() => {
          if (!(showPaymentForm && !!clientSecret)) {
            setNumberOfPayments('24');
            setIsForever(false);
            // Clear payment intent when number of payments changes
            if (clientSecret) {
              setClientSecret(null);
              setShowPaymentElement(false);
              setShowPaymentForm(false);
              setPaymentIntentId(null);
              paymentIntentCreatedRef.current = false;
              if (onClientSecretChange) {
                onClientSecretChange(null);
              }
            }
          }
        }}
        disabled={(preservedIsForever || isForever) || (showPaymentForm && !!clientSecret)}
      >
        24 mo
      </button>
      <button
        className={`${styles.shortcutButton} ${(preservedIsForever || isForever) ? styles.selected : ''}`}
        type="button"
        onClick={() => {
          if (!(showPaymentForm && !!clientSecret)) {
            if (preservedIsForever || isForever) {
              setIsForever(false);
              setNumberOfPayments('');
            } else {
              setIsForever(true);
              setNumberOfPayments('forever');
            }
            // Clear payment intent when switching between unlimited and limited
            if (clientSecret) {
              setClientSecret(null);
              setShowPaymentElement(false);
              setShowPaymentForm(false);
              setPaymentIntentId(null);
              paymentIntentCreatedRef.current = false;
              if (onClientSecretChange) {
                onClientSecretChange(null);
              }
            }
          }
        }}
        disabled={showPaymentForm && !!clientSecret}
      >
        Unlimited
      </button>
    </div>
      </div>
    </>
  );
}
